import Layouts from "./layouts";
import ACSStream from "./stream/acsStream";
import streamNull from "./stream/nullStream";
import {LayoutsLibConfiguration, LayoutsStream } from "./types";
import callbackRegistry, { CallbackRegistry } from "callback-registry";

export default function(config: LayoutsLibConfiguration): Layouts {

    if (!config.agm) {
        throw Error("config.agm is required");
    }

    if (!config.logger) {
        throw Error("config.logger is required");
    }

    // default mode to slim
    config.mode = config.mode || "slim";

    const logger = config.logger;
    const callbacks: CallbackRegistry = callbackRegistry();

    let acsStream: LayoutsStream;

    if (config.mode === "full" || "fullWaitSnapshot") {
        acsStream = new ACSStream(config.agm, callbacks);
    } else {
        acsStream = streamNull();
    }

    return new Layouts(config, acsStream, callbacks, logger);
}
